import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const subscriptionCustomerListTableHead: TableHeadItemRecurse[] = [
  { title: 'Cliente', flex: 2 },
  { title: 'Assessor', flex: 2 },
  { title: 'Telefone', flex: 1.5 },
  { title: 'E-mail', flex: 2 },
  { title: 'Qtd. Disponível' },
  { title: 'Qtde. Solicitada', flex: 1.5 },
  { title: '' },
];
